import React from 'react';
 // Import CSS specific to Footer

const Footer = () => {
    return (
        <footer className="main-footer">
            {/* <strong>
                        Copyright &copy; {new Date().getFullYear()}{' '}
                        <a href="https://www.vijayadiagnostic.com/" target="_blank" rel="noopener noreferrer">
                            Vijaya Diagnostic Centre
                        </a>. All rights reserved.
                    </strong> */}
                    <strong>
					© {new Date().getFullYear()} All rights reserved VDC</strong> 
                    <span style={{float:'right'}}>For Support Drop an email to it@vijayadiagnostic.in</span> 
        </footer>
    );
};

export default Footer;